module.exports = __webpack_public_path__ + "static/home-intro-2-a6c77453d356335f5e7cc0ce6c362e6b.svg";